import { render, staticRenderFns } from "./Legs.vue?vue&type=template&id=66c65b62&scoped=true&"
import script from "./Legs.vue?vue&type=script&lang=js&"
export * from "./Legs.vue?vue&type=script&lang=js&"
import style0 from "./Legs.vue?vue&type=style&index=0&id=66c65b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c65b62",
  null
  
)

/* custom blocks */
import block0 from "./Legs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports